// system_settings.meetingTime is stored as 24-hour "HH:MM" but every other time in
// the app is rendered 12-hour, so "22:00" in a banner reads as a different app.
export const formatTime = (value) => {
  if (!value) return '';
  const [rawHour, rawMinute = '00'] = String(value).split(':');
  const hour = Number(rawHour);
  if (Number.isNaN(hour)) return String(value);
  const suffix = hour >= 12 ? 'PM' : 'AM';
  const hour12 = hour % 12 === 0 ? 12 : hour % 12;
  return `${hour12}:${String(rawMinute).padStart(2, '0')} ${suffix}`;
};

// 0 = Sunday, matching system_settings.meetingDay
export const WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const weekdayName = (index, fallback = 'Saturday') => WEEKDAYS[Number(index)] ?? fallback;
